<app-ff-cabinet-head titleKey="header.searchOrders" titleFallback="Поиск запросов"></app-ff-cabinet-head>
<p class="found" *ngIf="!loading && !error">{{ t('ffSearch.found', 'Найдено запросов: {n}').replace('{n}', '' + totalElements) }}</p>

<!-- Быстрый выбор типа перевозки; остальные условия — под «Ещё фильтры» -->
<div class="quick">
  <div class="rate-chips" role="group" [attr.aria-label]="rateTypeText">
    <button type="button" class="rate-chip" [class.rate-chip--on]="!filterForm.value.rateType" (click)="setRateType(null)">
      {{ t('ffSearch.allTypes', 'Все') }}
    </button>
    <button type="button" class="rate-chip" *ngFor="let rt of rateTypes" [class.rate-chip--on]="filterForm.value.rateType === rt.value" (click)="setRateType(rt.value)">
      {{ rateLabel(rt.value) }}
    </button>
  </div>
  <app-assignee-filter *ngIf="canFilterManagers" kind="manager" [value]="managerFilter"
                       (changed)="onManagerFilter($event)"></app-assignee-filter>
  <button type="button" class="more-filters" [class.more-filters--on]="filtersOpen || extraFiltersCount > 0" (click)="filtersOpen = !filtersOpen" [attr.aria-expanded]="filtersOpen">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>
    {{ t('ffSearch.moreFilters', 'Ещё фильтры') }}
    <span class="more-filters__count" *ngIf="extraFiltersCount > 0">{{ extraFiltersCount }}</span>
  </button>
</div>

<section class="pp-card filters-card" *ngIf="filtersOpen">
  <form [formGroup]="filterForm" class="filters-form" (ngSubmit)="searchRequests(); filtersOpen = false">
    <div class="filters-grid">
      <div class="pp-field">
        <label>{{ fromCountryText }}</label>
        <app-country-select formControlName="fromCountryId" [countries]="countries" [placeholder]="selectAllText"></app-country-select>
      </div>
      <div class="pp-field">
        <label>{{ fromCityText }}</label>
        <input type="text" formControlName="fromCity" />
      </div>
      <div class="pp-field">
        <label>{{ toCountryText }}</label>
        <app-country-select formControlName="toCountryId" [countries]="countries" [placeholder]="selectAllText"></app-country-select>
      </div>
      <div class="pp-field">
        <label>{{ toCityText }}</label>
        <input type="text" formControlName="toCity" />
      </div>
      <div class="pp-field">
        <label>{{ loadingDateFromText }}</label>
        <input type="date" formControlName="loadingDateFrom" />
      </div>
      <div class="pp-field">
        <label>{{ loadingDateToText }}</label>
        <input type="date" formControlName="loadingDateTo" />
      </div>
      <div class="pp-field">
        <label>{{ priceFromText }}</label>
        <input type="number" formControlName="priceFrom" step="0.01" min="0" />
      </div>
      <div class="pp-field">
        <label>{{ priceToText }}</label>
        <input type="number" formControlName="priceTo" step="0.01" min="0" />
      </div>
      <div class="pp-field">
        <label>{{ currencyText }}</label>
        <select formControlName="currencyId">
          <option [ngValue]="null">{{ selectAllText }}</option>
          <option *ngFor="let currency of currencies" [ngValue]="currency.id">{{ currency.name || currency.code }}</option>
        </select>
      </div>
      <div class="pp-field">
        <label>{{ calculateCustomsPaymentsText }}</label>
        <select formControlName="calculateCustomsPayments">
          <option [ngValue]="null">{{ selectAllText }}</option>
          <option [ngValue]="true">{{ yesText }}</option>
          <option [ngValue]="false">{{ noText }}</option>
        </select>
      </div>
    </div>
    <div class="filters-actions">
      <button type="button" (click)="clearFilters()" class="pp-btn pp-btn--ghost">{{ clearFiltersText }}</button>
      <button type="submit" class="pp-btn pp-btn--primary">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
        {{ t('ffSearch.show', 'Показать') }}
      </button>
    </div>
  </form>
</section>

<div *ngIf="error" class="pp-card"><div class="pp-error">{{ error }}</div></div>
<div *ngIf="loading" class="pp-card"><div class="pp-loading">{{ loadingText }}</div></div>
<div *ngIf="!loading && !error && requests.length === 0" class="pp-card">
  <div class="pp-empty">
    {{ noRequestsText }}
    <button type="button" class="pp-btn pp-btn--ghost empty-reset" *ngIf="extraFiltersCount > 0 || filterForm.value.rateType" (click)="clearFilters()">{{ clearFiltersText }}</button>
  </div>
</div>

<!-- Карточка запроса: маршрут крупно, ключевые цифры строкой, действие справа -->
<ul class="req-list" *ngIf="!loading && !error && requests.length > 0">
  <li *ngFor="let r of requests" class="req-card" [class.req-card--closed]="r.hasDeal">
    <div class="req-card__main" (click)="openRequest(r)" (keydown.enter)="openRequest(r)" [attr.tabindex]="r.hasDeal ? null : 0" role="link">
      <div class="req-card__top">
        <span class="req-card__num">{{ requestNo(r) }}</span>
        <span class="rate-pill">{{ rateLabel(r.rateType) }}</span>
        <span class="req-card__manager" *ngIf="r.forwarderManagerName">{{ t('company.assign.managerColumn', 'Менеджер') }}: {{ r.forwarderManagerName }}</span>
        <span class="req-card__open" aria-hidden="true">{{ t('ffRequest.openRequest', 'Открыть запрос') }}
          <svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg>
        </span>
      </div>

      <h3 class="req-card__route">
        {{ r.fromCity }} <span class="arrow" aria-hidden="true">→</span> {{ r.toCity }}
      </h3>
      <p class="req-card__countries">{{ countryName(r.fromCountryId) }} → {{ countryName(r.toCountryId) }}</p>

      <dl class="req-card__facts">
        <div>
          <dt>{{ loadingDateText }}</dt>
          <dd>{{ r.loadingDate | date:'dd.MM.yyyy' }}</dd>
        </div>
        <div>
          <dt>{{ t('ffSearch.weight', 'Вес') }}</dt>
          <dd>{{ fmtWeight(getTotalWeight(r)) }}</dd>
        </div>
        <div>
          <dt>{{ t('ffSearch.volume', 'Объём') }}</dt>
          <dd>{{ fmtVolume(getTotalVolume(r)) }}</dd>
        </div>
        <div>
          <dt>{{ t('ffSearch.places', 'Мест') }}</dt>
          <dd>{{ placesCount(r) }}</dd>
        </div>
        <div>
          <dt>{{ priceText }}</dt>
          <dd>{{ fmtMoney(r.price, r.currencyId) }}</dd>
        </div>
      </dl>
      <p class="req-card__customs" *ngIf="r.calculateCustomsPayments">
        {{ t('ffSearch.needsCustoms', 'Клиенту нужен и расчёт таможенных платежей') }}
      </p>
    </div>

    <div class="req-card__side">
      <!-- Статус запроса; если ставка уже есть — рядом «Моя ставка» -->
      <div class="req-card__status">
        <span class="pp-badge" [ngClass]="'pp-badge--' + requestTone(r)">{{ cardStatus(r) }}</span>
        <button *ngIf="cardState(r) === 'mine'" type="button" class="my-bid-pill" (click)="openRequest(r)">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
          {{ t('ffSearch.myBid', 'Моя ставка') }}
        </button>
      </div>
      <ng-container [ngSwitch]="cardState(r)">
        <button *ngSwitchCase="'open'" type="button" class="pp-btn pp-btn--primary req-card__cta" (click)="makeBid(r)">
          {{ makeBidText }}
        </button>
      </ng-container>
    </div>
  </li>
</ul>

<div *ngIf="!loading && totalPages > 1" class="pager">
  <button type="button" class="pp-btn pp-btn--ghost" [disabled]="currentPage === 0" (click)="onPageChange(currentPage - 1)">{{ previousPageText }}</button>
  <span class="pager__info">{{ pageInfoText }} {{ currentPage + 1 }} {{ ofText }} {{ totalPages }}</span>
  <button type="button" class="pp-btn pp-btn--ghost" [disabled]="currentPage >= totalPages - 1" (click)="onPageChange(currentPage + 1)">{{ nextPageText }}</button>
</div>
